import moment from 'moment';
import * as _ from 'underscore';

import React, { Component } from 'react';
import { connect } from 'react-redux';

import CircularProgress from 'material-ui/Progress';

import CONF from '../../../../api/config';
import * as DesignerTOCState from '../../../../state/reducer/designerTOC/designerTOC';
import * as CalendarState from '../../../../state/reducer/calendar/calendar';
import { FEATURES } from '../../../../v5/features/components/constants';
import Session from '../../../calendar/components/Session';
import InfiniteCalendar from './InfiniteCalendar';
import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../../../lib/segment/SegmentService';
import Console from '../../../../lib/debug';

export class DesignerPreviewClass extends Component {
    state = {
        date: this.props.currentDay
    };

    loadingState = () => {
        return (
            <section className="empty-state">
                <CircularProgress size={30} />
                <span>Loading month</span>
            </section>
        );
    };

    restDaySession = () => {
        return (
            <section className="empty-state">
                <div>
                    <i className="mdi mdi-sleep" />
                </div>
                <span>Scheduled Rest Day</span>
            </section>
        );
    };

    onTrackPreview() {
        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Lefthand Session builder',
            ctaText: 'Preview Session icon'
        });
    }

    getSessionsOnCurrentDay = () => {
        const sessionsOnCurrentDay = [];
        const sessions = this.props.sessions || [];
        const currentDay = moment(this.state.date, 'YYYY_M_D');
        for (let i = 0; i < sessions.length; i++) {
            const session = sessions[i];
            const sessionDate = moment(session.date, 'YYYY-M-D');
            if (currentDay.format() != sessionDate.format()) continue;

            const previewUrl = `/fullscreen-workout/${session.workout_id}`;

            sessionsOnCurrentDay.push(
                <div style={{ position: 'relative' }}>
                    <Session
                        key={session.id}
                        session={session}
                        isPreview={true}
                    />
                    <a
                        className="athlete-web-preview"
                        href={previewUrl}
                        onClick={this.onTrackPreview}
                        target="_blank"
                    >
                        <i className="mdi mdi-open-in-new" />
                    </a>
                </div>
            );
        }
        return sessionsOnCurrentDay;
    };

    getSessions = () => {
        if (this.props.tocLoading) {
            return this.loadingState();
        }
        const sessions = this.getSessionsOnCurrentDay();
        if (sessions.length === 0) {
            return this.restDaySession();
        }
        return sessions;
    };

    handleEnter = date => {
        this.setState({ date });
    };

    handleLeave = () => {
        this.setState({ date: this.props.currentDay });
    };

    navigate = date => {
        const _date = new Date(date);
        const dateObj = {
            month: _date.getMonth() + 1,
            day: _date.getDate(),
            year: _date.getFullYear()
        };
        DesignerTOCState.gotoProgramDay(dateObj, this.props.programType);

        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Lefthand Session builder',
            ctaText: 'Calendar Dates'
        });
    };

    handleScroll = (scrollTop, date) => {
        if (!this.props.programId) {
            return;
        }

        const day = moment(date).add(15, 'days');
        return CalendarState.loadProgramWorkouts(
            this.props.programId,
            this.props.programType,
            day.year(),
            day.month()
        );
    };

    render() {
        Console.render('DesignerPreview');
        if (!this.props.currentDay) return null;

        const currentDay = moment(this.state.date, 'YYYY_M_D');
        const dayLabel = currentDay.format('dddd MMM D, YYYY');

        return (
            <div className="designer-toc-wrapper">
                <div className="designer-toc">
                    <div className="designer-toc-inner">
                        <div className="layout-column">
                            <InfiniteCalendar
                                currentDay={this.props.currentDay}
                                handleEnter={this.handleEnter}
                                handleLeave={this.handleLeave}
                                handleScroll={this.handleScroll}
                                navigate={this.navigate}
                                isPubEnabled={this.props.isPubEnabled}
                                sessionCount={this.props.sessions.length}
                                sessionsForCalendar={
                                    this.props.sessionsForCalendar
                                }
                                trainingWeekStartsOnMonday={
                                    this.props.trainingWeekStartsOnMonday
                                }
                            />
                        </div>
                        <div className="toc-day-preview cal-type">
                            <p className="session-preview-title">
                                Session Preview
                            </p>
                            <p className="preview-date">{dayLabel}</p>
                            <ol className="calendar-items-list the-day">
                                {this.getSessions()}
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const tocSessions = [];
    const sessionsForCalendar = {};
    const sessionKeys = _.keys(state.calendar.sessionTree);
    for (let i = 0; i < sessionKeys.length; i++) {
        const key = sessionKeys[i];
        const session = { ...state.calendar.sessionTree[key].data };
        if (session.workout_id === 'fakeSession') continue;
        session.setKeys =
            state.calendar.sessionTree[session.workout_id].data.setKeys;
        session.sets = state.calendar.sessionTree[session.workout_id].data.sets;
        tocSessions.push(session);

        if (!sessionsForCalendar[session.year])
            sessionsForCalendar[session.year] = {};
        if (!sessionsForCalendar[session.year][session.month])
            sessionsForCalendar[session.year][session.month] = {};
        if (!sessionsForCalendar[session.year][session.month][session.day])
            sessionsForCalendar[session.year][session.month][session.day] = [];
        sessionsForCalendar[session.year][session.month][session.day].push({
            data: session,
            date: session.date
        });
    }

    const calendar = state.calendar;
    const infoTree = calendar ? calendar.infoTree : null;
    const team = infoTree ? infoTree.team : null;
    const programId = infoTree ? infoTree.programId : null;
    const teamId = team ? team.group_id : programId;

    return {
        sessions: tocSessions,
        sessionsForCalendar: sessionsForCalendar,
        isPubEnabled: state.calendar.uiTree.isPubEnabled,
        programType: state.calendar.infoTree.programType,
        programId: state.calendar.infoTree.programId,
        teamId,
        currentDay: state.calendar.infoTree.designerInfo.dayId,
        tocLoading: state.calendar.uiTree.tocLoading,
        trainingWeekStartsOnMonday:
            state.app &&
            state.app.userProfile &&
            state.app.userProfile.training_week_starts_on_monday,
        ...ownProps
    };
};

export default connect(mapStateToProps)(DesignerPreviewClass);
